import {getImageScreenURL, getUrlForImageItemScreenTier, ScreenTier} from '@Libraries/image-item.library';
import {getImageThumbUrlForSource} from '@Libraries/graphic-item-image-library';
import {getCorsReadUrl} from '@Libraries/pmw-stock-media-library';
import {imageUrlToDataUrlOrNull} from '@Utils/image.util';
import type {QRLogoReference} from '@Libraries/qr-code/qr-code.types';

/**
 * An upload older than the tiered screen layout only holds the legacy `screens/<hash>.<ext>` file, and
 * nothing regenerates tiers on poster load, so a high-res render falls back to it rather than dropping a
 * logo the editor shows from the thumb.
 */
export const getQRLogoHighResUrls = (logo: QRLogoReference): string[] => {
  return [
    getUrlForImageItemScreenTier(logo.hashedFilename, logo.source, ScreenTier.SMALL),
    getImageScreenURL(logo.hashedFilename, logo.fileExtension, logo.source),
  ].map(getCorsReadUrl);
};

export const getQRLogoThumbUrl = (logo: QRLogoReference): string => {
  return getCorsReadUrl(getImageThumbUrlForSource(logo.hashedFilename, logo.fileExtension, logo.source));
};

/** The data URL of the first candidate that inlines, or null when none does. */
export const inlineFirstAvailableImage = async (urls: string[]): Promise<string | null> => {
  for (const url of urls) {
    // eslint-disable-next-line no-await-in-loop -- candidates are fallbacks for one another, so each is tried only after the previous fails
    const dataUrl = await imageUrlToDataUrlOrNull(url);
    if (dataUrl !== null) {
      return dataUrl;
    }
  }
  return null;
};
